<template>
    <!-- <div class="notifications"></div> -->
    <div class="controls_all" v-bind:class="[{answer: $store.getters.item_correct === 'true'}, {answer: $store.getters.item_correct  === 'false'}]" v-if="$route.name === 'customise' || game_play">
        <div class="gender_selector info" v-if="game_play">
            <router-link :to="{name: 'instructions'}">
                <img class="btn_male info_icon" src="../../public/assets/icons/RS-PPE-ICONS-QUESTION.svg" alt="">
            </router-link>
            <router-link :to="{name: 'instructions', params: {icon: 'i'}}" class="info_svg">
                <img class="btn_female info_icon" src="../../public/assets/icons/RS-PPE-ICONS-INFO.svg" alt="">
            </router-link>
        </div>
    <div v-bind:class="[{char_active:controls}, {char_hidden:!controls}]" class="controls_character">
        <div class="gender_selector" v-if="!game_play">
            <p class="gender_label male_label" v-bind:class="[{active_gender:male}, {passive_gender:!male}]">{{ $t('instructions.customise.male_label') }}</p>
            <img v-on:click="setCharacter('male')" v-bind:class="[{active:male}, {passive:!male}]" class="btn_male" src="../../public/assets/icons/male.svg" alt="">
            <p class="gender_label female_label" v-bind:class="[{active_gender:female}, {passive_gender:!female}]">{{ $t('instructions.customise.female_label') }}</p>
            <img v-on:click="setCharacter('female')" v-bind:class="[{active:!male}, {passive:male}]" class="btn_female" src="../../public/assets/icons/female.svg" alt="">
        </div>

        <div class="tone_selector">
            <p class="control_title">{{ $t('instructions.customise.skin_tone') }}</p>
            <ul>
                <li style="background-color: #FFDDA1;" data-tone="tone-0"></li>
                <li style="background-color: #E5A565;" data-tone="tone-1"></li>
                <li style="background-color: #A06042;" data-tone="tone-2"></li>
            </ul>
        </div>

        <div class="hair_selector">
            <p class="control_title" v-html="$t('instructions.customise.hair_color')"></p>
            <ul>
                <li style="background-color: #675556;" data-col="g-h-col-0"></li>
                <li style="background-color: #EFD770;" data-col="g-h-col-1"></li>
                <li style="background-color: #BE6D23;" data-col="g-h-col-2"></li>
                <li style="background-color: #332D2F;" data-col="g-h-col-3"></li>
            </ul>
        </div>

        <div class="continue_botton" style="position: absolute; top: calc(80% - 100px); left: calc(50% - 77px); z-index: 9999;" v-if="!game_play" >
        <router-link :to="{ name: 'ready', params: {level: 'logistics'} }" class="primary_btn">{{ $t('buttons.continue_button') }}</router-link>
        </div>

        <div class="face_selector">
            <div class="hairstyle_selector arrow_selector"><ul><li></li>
            <li></li></ul></div>
            <div class="facialstyle_selector arrow_selector"><ul><li></li>
                <li></li></ul></div>
        </div>
    </div>
    <div class="colors_control" v-if="controls && !game_play">
        <div class="hair">
            <p class="hair_style_text">{{ $t('instructions.customise.hairstyle') }}</p>
        </div>
        <div class="facial">
            <p class="facial_hair_text">{{ $t('instructions.customise.facial_hair') }}</p>
        </div>
    </div>
    <div class="controls_game">
        <div class="progress_numbers" v-if="game_play">
            <p class="text_counter head_counter"  v-if="level === 'logistics'">{{ $store.state.part_head_correct === null ? '0/1' : '1/1' }}</p>
            <p class="text_counter head_counter" v-if="level === 'lab' || level === 'construction'">{{ head_counter === ''? '0/2' : head_counter }}</p>
            <p class="text_counter torso_counter"  v-if="level === 'lab' || level === 'construction'">{{ $store.state.part_torso_correct === null ? '0/1' : '1/1' }}</p>
            <p class="text_counter torso_counter" v-if="level === 'logistics'">{{ torso_counter === ''? '0/2' : torso_counter }}</p>
            <p class="text_counter hand_counter">{{ $store.state.part_hand_correct === null ? '0/1' : '1/1' }}</p>
            <p class="text_counter feet_counter">{{ $store.state.part_feet_correct === null ? '0/1' : '1/1' }}</p>
        </div>
        <div class="parts_covered" v-if="game_play">
            <img class="part_head progress_bar" src="/assets/icons/male_head_blank.svg" alt="" v-if="$store.state.part_head_correct === null && male">
            <img class="part_head progress_bar" src="/assets/icons/male_head_half.svg" alt="" v-if="$store.state.part_head_correct === 'some' && male">
            <img class="part_head progress_bar" src="/assets/icons/male_head_full.svg" alt="" v-if="$store.state.part_head_correct === 'all' && male">
            <img class="part_head progress_bar" src="/assets/icons/female_head_blank.svg" alt="" v-if="$store.state.part_head_correct === null && female">
            <img class="part_head progress_bar" src="/assets/icons/female_head_half.svg" alt="" v-if="$store.state.part_head_correct === 'some' && female">
            <img class="part_head progress_bar" src="/assets/icons/female_head_full.svg" alt="" v-if="$store.state.part_head_correct === 'all' && female">
            <img class="part_torso progress_bar" src="/assets/icons/torso_blank.svg" alt="" v-if="$store.state.part_torso_correct === null">
            <img class="part_torso progress_bar" src="/assets/icons/torso_half.svg" alt="" v-if="$store.state.part_torso_correct === 'some'">
            <img class="part_torso progress_bar" src="/assets/icons/torso_full.svg" alt="" v-if="$store.state.part_torso_correct === 'all'">
            <img class="part_hand progress_bar" src="/assets/icons/hand_blank.svg" alt="" v-if="$store.state.part_hand_correct === null">
            <img class="part_hand progress_bar" src="/assets/icons/hand_full.svg" alt="" v-if="$store.state.part_hand_correct === 'all'">
            <img class="part_feet progress_bar" src="/assets/icons/feet_blank.svg" alt="" v-if="$store.state.part_feet_correct === null">
            <img class="part_feet progress_bar" src="/assets/icons/feet_full.svg" alt="" v-if="$store.state.part_feet_correct === 'all'">
        </div>
        <img v-on:click="enableControls()" v-bind:class="[{active:controls}, {passive:!controls}]" class="customise_char" src="../../public/assets/icons/head_icon.svg" alt="" v-if="customise">
    </div>
    <transition enter-active-class="bounceIn">
        <div class="box" v-if="$store.getters.item_correct === 'true' && !$store.getters.message">
            <p class="notification_title success">{{ $t('game.notification.correct.title') }}</p>
            <p class="notification_description">{{ $t('game.notification.correct.description') }}</p>
        </div>
    </transition>
    <transition enter-active-class="bounceIn">
        <div class="box" v-if="$store.getters.item_correct === 'false' && !$store.getters.message">
            <p class="notification_title danger">{{ $t('game.notification.false.title') }}</p>
            <p class="notification_description">{{ $t('game.notification.false.description') }}</p>
        </div>
    </transition>
    <transition enter-active-class="bounceIn">
        <div class="box" v-if="$store.getters.item_correct === 'false' && $store.getters.message">
            <p class="notification_title danger">{{ $t('game.notification.false.title') }}</p>
            <p class="notification_description">{{ $t('game.notification.false.description') }}</p>
        </div>
    </transition>
    </div>
</template>

<script>
    import json from '@/main.json';
    export default {
    name: 'AppGameControl',
    props: ['level'],
    components: {
    },
    data() {
        return {
            json,
            data: '',
            male: '',
            female: '',
            customise: false,
            game_play: '',
            torso: '',
            item_correct: '',
            controls: false,
            characterTone: '',
            characterItems: '',
            characterGender: '',
            characterClasses: '',
            characterHairTone: '',
            characterHairStyle: '',
            characterFacialHair: '',
            head_progress: '',
            torso_progress: '',
            hand_progress: '',
            feet_progress: '',
            head_counter: '',
            torso_counter: '',
            items: localStorage.getItem('characterClasses') ? 
                   JSON.parse(localStorage.getItem('characterClasses')) : ''
        }
    },
    methods: {
        updateClasses: function(){
            if (JSON.parse(localStorage.getItem('characterItems')).includes('bui-hardhat')) {
                document.querySelector('svg').classList.remove('g-nohardhat');
                document.querySelector('svg').classList.add('g-hardhat');
            } else {
                document.querySelector('svg').classList.remove('g-hardhat');
                document.querySelector('svg').classList.add('g-nohardhat');
            }
            if (JSON.parse(localStorage.getItem('characterItems')).includes('log-fleecejacket')) {
                document.querySelector('svg').classList.remove('g-nofleecejacket');
                document.querySelector('svg').classList.add('g-fleecejacket');
            } else {
                document.querySelector('svg').classList.remove('g-fleecejacket');
                document.querySelector('svg').classList.add('g-nofleecejacket');
            }
            // console.log('this gender '+this.characterGender)
        },
        checkHeadProgress(newCount){
            if(newCount === 'all'){ 
                return this.head_counter = '2/2';
            }else if(newCount === 'some')
            { 
                return this.head_counter = '1/2';
            }else {
                return this.head_counter = '0/2';
            }
            // console.log('Dude head counter is: ' + this.head_counter);
        },
        checkTorsoProgress(newCount){
            if(newCount === 'all'){ 
                return this.torso_counter = '2/2';
            }else if(newCount === 'some')
            { 
                return this.torso_counter = '1/2';
            }else {
                return this.torso_counter = '0/2';
            }
            // console.log('Dude head counter is: ' + this.head_counter);
        },
        setItems: function(){
                var items = JSON.parse(localStorage.getItem('characterItems'));
                function isempty(x){ if(x!=="") return true;}
                var res = items.filter(isempty);
                var arrayLength = res.length;
                this.updateClasses();
                res.forEach(function(item){
                    document.querySelectorAll('.'+item+'').forEach(function(e){
                        e.style.display = 'block';
                    }); 
                    // document.querySelector("#img-"+item).classList.add('correct_item');
                    document.querySelectorAll("#img-"+item).forEach(function(e){
                        e.classList.add('correct_item');
                    }); 

                })
                document.querySelector('svg').classList.add(this.characterGender ? this.characterGender: 'g-male');
                document.querySelector('svg').classList.add(this.characterTone, this.characterHairStyle, this.characterFacialHair, this.characterHairTone);
        },
        setCharacter: function(gender) {
            // console.log('Changing to ' + gender + ' character')
            // Set the respective character selected by user to true
            gender === 'male' ? (this.male = true) && (this.female = false) : 
                                (this.female = true) && (this.male = false);
            // Pop last item gender of array
            this.characterClasses.pop();

            // Push new gender item to the array
            this.male ? this.characterClasses.push('g-male') : this.characterClasses.push('g-female');
            
            // Store the object in localhost
            localStorage.setItem('characterClasses', JSON.stringify(this.characterClasses));
            // Check if g-male already exists and remove it
            document.querySelector('svg').classList.contains('g-male') && !this.male ? 
                        document.querySelector('svg').classList.remove('g-male') : null;
            // Check if g-female already exists and remove it
            document.querySelector('svg').classList.contains('g-female') && !this.female ? 
                        document.querySelector('svg').classList.remove('g-female') : null;
            this.male ? (document.querySelector('svg').classList.add('g-male')) && 
                        (document.querySelector('svg').classList.remove('g-female')): 
                        (document.querySelector('svg').classList.add('g-female')) && 
                        document.querySelector('svg').classList.remove('g-male');
            // console.log(gender);
            // console.log('Selector ' + document.querySelector('svg').classList.contains('g-male'));
            // console.log(this.male);
            // console.log(this.female);
            // console.log(JSON.parse(localStorage.getItem('characterClasses')).slice(-1)[0]);
            var get_gender = JSON.parse(localStorage.getItem('characterClasses')).slice(-1)[0];
            localStorage.setItem('characterGender', get_gender); // set selected gender in localstorage
            JSON.parse(localStorage.getItem('characterClasses')).forEach(function(element) {
                document.querySelector('svg').classList.add(element);
            });
        },
        hidePulse: function() {
            document.querySelector('#target_torso').style.display = 'none';
            document.querySelector('#target_head').style.display = 'none';
            document.querySelector('#target_hand').style.display = 'none';
            document.querySelector('#target_feet').style.display = 'none';
        },
        enableControls(){
            this.controls ? this.controls = false : this.controls = true;
        },
        resetStores() {
            this.$store.commit('set_part_head_correct', null);
            this.$store.commit('set_part_torso_correct', null);
            this.$store.commit('set_part_hand_correct', null);
            this.$store.commit('set_part_feet_correct', null);
        }
    },
    computed: {
        itemCorrect() {
            return this.$store.getters.item_correct;
        },
        headCounter() {
            return this.$store.state.part_head_correct;
        },
        torsoCounter() {
            return this.$store.state.part_torso_correct;
        },
        handCounter() {
            return this.$store.state.part_hand_correct;
        },
        feetCounter() {
            return this.$store.state.part_feet_correct;
        }
    },
    mounted() {
        /*
         * Mounted state
         * Make this available once DOM is mounted
         */
      // console.log(this.$store.state.part_head_correct);
      // console.log(this.$store.state.part_torso_correct);
      // console.log(this.$store.state.part_hand_correct);
      // console.log(this.$store.state.part_feet_correct);

        this.resetStores();
        localStorage.setItem('characterItems', JSON.stringify(['']));
        this.updateClasses();
        
        let curHair = 2;
        let curFacial = 0;
        this.torso = json;
        // console.log('progress: '+json.progress.male.head_full);
        const faceVars = {
          "hairStyle": ["g-hair", "g-hair-shaved", "g-hair-short", "g-hair-long"],
          "facialHair": ["g-facial", "g-facial-beard", "g-facial-goatee", "g-facial-stubble"]
        };
        const updateFace = () => {
            faceVars.hairStyle.forEach(function(el){
                document.querySelector('svg').classList.remove(el);
            });
            faceVars.facialHair.forEach(function(el){
                document.querySelector('svg').classList.remove(el);
            });
            document.querySelector('svg').classList.add(faceVars.hairStyle[curHair]);
            document.querySelector('svg').classList.add(faceVars.facialHair[curFacial]);
            localStorage.setItem('characterHairStyle', faceVars.hairStyle[curHair]);
            localStorage.setItem('characterFacialHair', faceVars.facialHair[curFacial]);
        }
        
        // this.hidePulse();
        this.characterItems != undefined ? null : localStorage.setItem('characterItems', JSON.stringify(['']));
        this.setItems();

        this.$route.name === 'game'? (document.querySelector('svg').style['z-index'] = 300) : null;
        this.$route.name === 'customise'? (document.querySelector('svg').style['z-index'] = 0) : null;

        // Eyes, follow the mouse
        document.addEventListener('mousemove', e => {
            let x = event.clientX/window.innerWidth - 0.5;   
            let y = event.clientY/window.innerHeight - 0.35;  
            document.querySelector("#IRIS").style.transform = "translateX("+15*x+"px) translatey("+15*y+"px)";
            document.querySelector("#IRIS-2").style.transform = "translateX("+15*x+"px) translatey("+15*y+"px)";
            document.querySelector("#IRIS-3").style.transform = "translateX("+15*x+"px) translatey("+15*y+"px)";
            document.querySelector("#IRIS-4").style.transform = "translateX("+15*x+"px) translatey("+15*y+"px)";
        });
        // Change skin tone
        document.querySelectorAll('.tone_selector ul li').forEach(function (el) {
            el.addEventListener('click', function () {
                document.querySelector('svg').classList.forEach(function (cl) {
                    if (cl.includes('tone-')) {
                        document.querySelector('svg').classList.remove(cl);
                    }
                });
                document.querySelector('svg').classList.add(this.dataset.tone);
                localStorage.setItem('characterTone', this.dataset.tone);
            })
        });
        // Change hair color
        document.querySelectorAll('.hair_selector ul li').forEach(function (el) {
            el.addEventListener('click', function () {
                document.querySelector('svg').classList.forEach(function (cl) {
                    if (cl.includes('g-h-col-')) {
                        document.querySelector('svg').classList.remove(cl);
                    }
                });
                document.querySelector('svg').classList.add(this.dataset.col);
                localStorage.setItem('hairTone', this.dataset.col);
            })
        });
        document.querySelectorAll('.face_selector ul li').forEach(function (el) {
            el.addEventListener('click', function () {
                if(el.parentNode.parentNode.classList.contains('facialstyle_selector')){
                    if(el.nextSibling){
                        curFacial--;
                        if(curFacial === -1){
                            curFacial = 3;
                        }
                    }
                    else{
                        curFacial++;
                        if(curFacial === 4){
                            curFacial = 0;
                        }
                    }
                }
                else{
                    if(el.nextSibling){
                        curHair--;
                        if(curHair === -1){
                            curHair = 3;
                        }                    }
                    else{
                        curHair++;
                        if(curHair === 4){
                            curHair = 0;
                        }
                    }
                }
                updateFace();
            })
        })
    },
    beforeMount(){
        // console.log(this.$store.state.item_correct);
        /*
         * Before Mounted state
         * Make this available before DOM is mounted
         */
        // Init items if there's nothing in localstorage
        this.characterClasses = localStorage.getItem('characterClasses') ? 
                   JSON.parse(localStorage.getItem('characterClasses')) : ['tone-0', 'g-h-col-0', 'g-hair', 'g-facial'];
        this.characterTone = localStorage.getItem('characterTone') ? 
                   localStorage.getItem('characterTone') : null;
        this.characterHairStyle = localStorage.getItem('characterHairStyle') ? 
                   localStorage.getItem('characterHairStyle') : null;
        this.characterFacialHair = localStorage.getItem('characterFacialHair') ? 
                   localStorage.getItem('characterFacialHair') : null;
        this.characterItems = localStorage.getItem('characterItems') ? 
                   JSON.parse(localStorage.getItem('characterItems')) : null;
        this.characterGender = localStorage.getItem('characterClasses') ? 
                   JSON.parse(localStorage.getItem('characterClasses')).slice(-1)[0] : localStorage.setItem('characterGender', 'g-male');
        this.characterHairTone = localStorage.getItem('hairTone') ? 
                   localStorage.getItem('hairTone'): null;
        this.male = localStorage.getItem('characterGender') === 'g-male' ? true : false;
        this.female = localStorage.getItem('characterGender') === 'g-female' ? true : false;
        this.$route.name === 'customise'? (this.controls = true) : null;
        this.$route.name === 'customise'? (localStorage.setItem('characterItems', JSON.stringify(['']))) : null;
        this.$route.name === 'ready'? (localStorage.setItem('characterItems', JSON.stringify(['']))) : null;
        this.$route.name === 'customise'? (this.game_play = false) : null;
        this.$route.name === 'game'? (this.game_play = true) : null;
        this.characterItems != undefined ? null : localStorage.setItem('characterItems', JSON.stringify(['']));
    },
    watch: {
      $route(to, from) {
        // console.log(to);
        // console.log(from);
        if(to.name === 'customise'){
            localStorage.setItem('characterItems', JSON.stringify(['']));
            this.controls = true;
            this.game_play = false;
            document.querySelector('svg').style['z-index'] = 0;
        } else if (to.name === 'ready') {
            localStorage.setItem('characterItems', JSON.stringify(['']));
        } else if (to.name === 'game') {
            this.controls = false;
            this.game_play = true;
            this.hidePulse();
            document.querySelector('svg').style['z-index'] = 300;
        }
      },
      headCounter(newCount, oldCount){
        // console.log('New head counter dude:' + newCount);
        this.checkHeadProgress(newCount);
      },
      torsoCounter(newCount, oldCount){
        // console.log('New torso counter dude:' + newCount);
        this.checkTorsoProgress(newCount);
      }
    }
    };
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
    .controls_character {
        transition: .3s;
        position: absolute;
        height: 100vh;
        width: 100%;
        left:0;
    }
    .char_hidden{
    opacity: 0 !important;
    }
    .char_active{
    opacity: 1 !important;
    }
    .gender_label {
        color: #b6b6b6;
        font-weight: bold;
    }
    .male_label {
        left: 5px;
        position: relative;
    }
    .female_label {
        left: 9px;
        position: relative;
    }
    .box {
        position: absolute;
        bottom: 300px;
        left: calc(53% - 181px);
        width: 315px;
        margin: 0 auto;
        z-index: 9999;
        background: #fff;
        padding: 1em;
    }
    .notification_title {
        text-align: center;
        font-size: 20px;
        margin: 20px auto;
    }
    .info {
        z-index: 101;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
    }
    .info_icon {
        width: 30px !important;
        opacity: 0.6 !important;
    }
    .success {
        color: green;
    }
    .danger {
        color: red;
    }
    .notification_description {
        text-align: center
    }
    .btn_male, 
    .btn_female, 
    .hair_selector > ul > li, 
    .tone_selector > ul > li, 
    .arrow_selector > ul > li {
        cursor: pointer;
    }
    .tone_selector > ul {
        left: 35px;
        position: relative;
    }
    .gender_selector {
        position: absolute;
        top: 10px;
        left: 10px;
        width: 80px;
        height: 300px;
    }
    .gender_selector img {
        transition: .3s;
        opacity: 0.5;
        width: 50px;
        height: auto;
    }
    .gender_selector img:hover {
        opacity: 1;
    }
    .gender_selector .active {
        opacity: 1;
    }
    .active_gender {
        color: #323232;
    }
    .tone_selector {
        position: absolute;
        top: calc(70% - 100px);
        right: 10px;
    }
    .face_selector {
        position: absolute;
        top: 50px;
        left: calc(52% - 119px);
        width: 220px;
    }
    .face_selector div{
        padding: 10px 0;
    }
    .arrow_selector ul{
        width: 100%;
        display: flex;
        margin: 0;
        padding: 0;
        justify-content: space-between;
        list-style: none;
    }
    .arrow_selector ul li {
        transition: .3s;
        position: relative;
        margin: 0;
        width: 0;
        height: 0;
        border-top: 15px solid transparent;
  border-bottom: 15px solid transparent;
  border-left: unset;
  border-right: 20px solid #b6b6b6;
    }
    .arrow_selector ul li:hover{
        border-right: 20px solid #707070;
    }
    .arrow_selector ul li:nth-of-type(2n){
        border-top: 15px solid transparent;
  border-bottom: 15px solid transparent;
  border-left: 20px solid #b6b6b6;
  border-right: unset;
    }
    .arrow_selector ul li:nth-of-type(2n):hover{
        border-left: 20px solid #707070;
    }
    .hair_selector {
        position: absolute;
        top: calc(40% - 100px);
        right: 10px;
    }
    .tone_selector ul,
    .hair_selector ul{
        margin: 0;
        padding: 0;
        position: relative;
    }
    .tone_selector ul {
        // left: 85px;
    }
    .hair_selector ul{
        left: 80px;
    }
    .tone_selector ul li,
    .hair_selector ul li {
        transition: .3s;
        width: 20px;
        height: 20px;
        list-style: none;
        border-radius: 20px;
        margin: 0 0 20px 0;
    }
    .tone_selector ul li:hover,
    .hair_selector ul li:hover {
        transform: scale(1.2);
    }
    .controls_all img{
        user-select: none;
    }
    .answer {
        z-index: 999 !important;
    }
    .control_title {
        color: #b6b6b6;
        font-weight: bold;
        font-size: 15px;
        text-align: right
    }
    .facial{
        bottom: 60px;
        position: relative;
        line-height: 5px;
    }
    .hair{
        top: 40px;
        position: relative;
        line-height: 5px;
    }
    .colors_control {
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        height: 180px;
        position: absolute;
        right: 10px;
        top: 20px;
    }
    .colors_control p {
        color: #b6b6b6;
    }
    .colors_control p.open_control {
        cursor: pointer;
        font-weight: bold;
        color: #ef0000;
        text-decoration: underline;
    }
    .facial_hair_text, .hair_style_text{
        font-weight: bold;
        text-align: right;
    }
    .progress_bar {
        opacity: 1;
        width: 35px;
        height: 35px;
    }
    .info_svg {
        top: 5px;
        position: relative;
    }
    .progress_numbers {
        display: -webkit-box;
        display: -ms-flexbox;
        display: flex;
        -webkit-box-orient: vertical;
        -webkit-box-direction: normal;
        -ms-flex-direction: column;
        flex-direction: column;
        -webkit-box-pack: justify;
        -ms-flex-pack: justify;
        justify-content: space-between;
        height: 180px;
        position: absolute;
        right: 50px;
        top: 20px;
    }
    .text_counter {
        font-size: 12px;
        font-weight: bold;
        font-family: century-gothic, sans-serif;
        color: #5f259f;
    }

    @media(max-height: 750px) {
        .tone_selector {
            top: calc(75% - 100px) !important;
        }
    }

    @media(max-width: 370px) {
        .tone_selector {
            top: calc(71% - 100px) !important;
        }
    }

    @media(min-width: 371px) and (max-width: 599px) {
        .tone_selector {
            top: calc(72.5% - 100px) !important;
        }
    }
    
</style>